export const css = {
	root: '_2mlZzEuO',
	quizSelectHidden: '_2x-6dsO5',
	quizSelectChoice: '_1V8BOy3U',
	quizSelectBlock: 'syHpIHTz',
	fieldset: '_2UtLsiu_',
	legend: '_3m-UTD14',
	' _key': 'dashboard-widgets/path'
};

export default css;
